/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifecycle_Delete_Not_EmptyInputs */

const en_lifecycle_delete_not_empty = /** @type {(inputs: Lifecycle_Delete_Not_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items were added in the meantime. Close this dialog and open it again to see what would be deleted.`)
};

const de_lifecycle_delete_not_empty = /** @type {(inputs: Lifecycle_Delete_Not_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inzwischen wurden Vorgänge hinzugefügt. Schließe den Dialog und öffne ihn erneut, um zu sehen, was gelöscht würde.`)
};

/**
* | output |
* | --- |
* | "Items were added in the meantime. Close this dialog and open it again to see what would be deleted." |
*
* @param {Lifecycle_Delete_Not_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_delete_not_empty = /** @type {((inputs?: Lifecycle_Delete_Not_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Delete_Not_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_delete_not_empty(inputs)
	return en_lifecycle_delete_not_empty(inputs)
});